export default class DtoModelUpload {
    constructor(obj) {
        this.stationType = obj.stationType
        this.name = obj.name
        this.content = obj.content
    }
}